import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { numberToCurrency } from '../../../services/utils';
import googleAnalytics from '../../../../services/google_analytics';
import plusIcon from '../../../../../images/icons/plus.svg';
import minusIcon from '../../../../../images/icons/minus.svg';
import binIcon from '../../../../../images/icons/bin.svg';
import { lineItemsActions } from '../../../actions';
import './LineItem.sass';
import ClickableDiv from '../../../../ui_kit/clickable_div/ClickableDiv';
import Select from '../../../../ui_kit/select/Select';
import DELIVERY_INTERVALS from '../../../../product/constants/delivery_intervals';

export function ProductPrice(props) {
  const { price, discount, quantity } = props;

  return (
    <div className="product-price">
      {Number(discount) > 0
        && (
          <>
            <div className="pricing">
              <div className="full-price">
                {numberToCurrency(price * quantity)}
              </div>
              <div className="price">
                {numberToCurrency((Number(price) * quantity) - Math.abs(Number(discount)))}
              </div>
            </div>
            <div className="discount">
              You save
              {' '}
              {numberToCurrency(Math.abs(discount))}
            </div>
          </>
        )}
      {Number(discount) === 0
        && (
          <div className="pricing">
            <div className="price">
              {numberToCurrency(price * quantity)}
            </div>
          </div>
        )}
    </div>
  );
}

ProductPrice.propTypes = {
  price: PropTypes.string.isRequired,
  discount: PropTypes.string.isRequired,
  quantity: PropTypes.number.isRequired,
};

class LineItem extends Component {
  updateLineItemQuantity = (quantity) => {
    const { lineItem, removeError, updateQuantityRequest } = this.props;

    removeError();

    const lineItemId = lineItem.id;

    const params = {
      order: {
        line_items_attributes: {
          0: {
            id: lineItemId,
            quantity,
          },
        },
      },
      id: lineItemId,
    };

    updateQuantityRequest(params);
  };

  updateLineItemFrequency = (frequency) => {
    const { lineItem, removeError, updateQuantityRequest } = this.props;

    removeError();

    const lineItemId = lineItem.id;

    const params = {
      order: {
        line_items_attributes: {
          0: {
            id: lineItemId,
            frequency,
          },
        },
      },
      id: lineItemId,
    };

    updateQuantityRequest(params);
  };

  onLineItemAddClick = () => {
    const { lineItem } = this.props;
    const { quantity } = lineItem;
    googleAnalytics.trackAddToBag(lineItem, 1);
    this.updateLineItemQuantity(quantity + 1);
  };

  onLineItemRemoveClick = () => {
    const { lineItem } = this.props;
    const { quantity } = lineItem;
    googleAnalytics.trackRemoveFromBag(lineItem, 1);
    this.updateLineItemQuantity(quantity - 1);
  };

  onLineItemDeleteClick = () => {
    const { lineItem } = this.props;
    const { quantity } = lineItem;
    googleAnalytics.trackRemoveFromBag(lineItem, quantity);
    this.updateLineItemQuantity(0);
  };

  render() {
    const { lineItem, uneditable } = this.props;

    return (
      <div className={classNames('product-container', { disabled: lineItem.loading, uneditable })}>
        <div className="product-image">
          <img src={lineItem.image} alt={lineItem.name} />
        </div>
        <div className="product-content">
          <div className="top-container">
            <div className="product-title-and-variant">
              <a href={lineItem.link}>
                <div className="product-title">
                  {lineItem.name}
                </div>
              </a>
              <div className="product-variant">
                {lineItem.variant}
              </div>
            </div>
            <ProductPrice
              price={lineItem.price}
              discount={lineItem.discount}
              quantity={lineItem.quantity}
            />
            <ClickableDiv
              className="product-delete"
              onClick={this.onLineItemDeleteClick}
            >
              <span>
                <img src={binIcon} alt="delete product" />
              </span>
            </ClickableDiv>
          </div>
          { lineItem.subscribable && (
            <div className="frequency">
              { uneditable && (
                `SHIPS ${DELIVERY_INTERVALS.ALL_INTERVALS[lineItem.frequency].toUpperCase()}`
              )}
              { !uneditable && (
                <Select
                  value={lineItem.frequency}
                  options={Object.keys(DELIVERY_INTERVALS.ALL_INTERVALS).map(
                    (key) => ({ value: key, label: `SHIPS ${DELIVERY_INTERVALS.ALL_INTERVALS[key].toUpperCase()}` }),
                  )}
                  onChange={(event) => {
                    this.updateLineItemFrequency(Number(event.target.value));
                  }}
                  className="select"
                />
              )}
            </div>
          )}
          <div className="bottom-container">
            <div className="quantity-buttons">
              <ClickableDiv
                className="quantity-button"
                tabIndex={0}
                onClick={this.onLineItemRemoveClick}
              >
                <img src={minusIcon} width="9px" height="1px" alt="decrease quantity" />
              </ClickableDiv>
              <div className="quantity">
                {lineItem.quantity}
              </div>
              <ClickableDiv
                className="quantity-button"
                onClick={this.onLineItemAddClick}
              >
                <img src={plusIcon} width="9px" alt="increase quantity" />
              </ClickableDiv>
            </div>
            <ClickableDiv
              className="product-delete"
              onClick={this.onLineItemDeleteClick}
            >
              <span>
                <img src={binIcon} alt="" />
              </span>
              Remove
            </ClickableDiv>
            <ProductPrice
              price={lineItem.price}
              discount={lineItem.discount}
              quantity={lineItem.quantity}
            />
          </div>
        </div>
      </div>
    );
  }
}

LineItem.propTypes = {
  lineItem: PropTypes.shape({
    id: PropTypes.number,
    quantity: PropTypes.number,
    loading: PropTypes.bool,
    image: PropTypes.string,
    link: PropTypes.string,
    name: PropTypes.string,
    variant: PropTypes.string,
    discount: PropTypes.string,
    price: PropTypes.string,
    sku: PropTypes.string,
    subscribable: PropTypes.bool,
    frequency: PropTypes.number,
  }).isRequired,
  uneditable: PropTypes.bool.isRequired,
  removeError: PropTypes.func.isRequired,
  updateQuantityRequest: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  setError: (error) => dispatch(lineItemsActions.setError(error)),
  removeError: () => dispatch(lineItemsActions.removeError()),
  updateQuantityRequest: (params) => dispatch(lineItemsActions.updateQuantityRequest(params)),
});

export default connect(null, mapDispatchToProps)(LineItem);
